import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSupportFill = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.3491 21.3344C12.5054 21.7482 14.4962 21.334 16.2378 20.5062H16.3208L20.3013 21.1683C20.7987 21.2511 21.213 20.8377 21.1304 20.3412L20.4673 16.3676V16.2845C21.3794 14.5464 21.711 12.4775 21.3794 10.3256C20.7159 6.4352 17.4814 3.20675 13.5835 2.62732C7.11475 1.55145 1.55825 7.09691 2.63623 13.5531C3.29971 17.4434 6.36832 20.6721 10.3491 21.3344ZM9.52393 13.6498C8.61128 13.6498 7.87158 12.9091 7.87158 11.9965C7.87182 11.084 8.61143 10.3441 9.52393 10.3441C10.4363 10.3443 11.176 11.0841 11.1763 11.9965C11.1763 12.909 10.4364 13.6496 9.52393 13.6498ZM14.481 13.6498C13.5684 13.6497 12.8286 12.9091 12.8286 11.9965C12.8289 11.0841 13.5685 10.3442 14.481 10.3441C15.3935 10.3441 16.1331 11.084 16.1333 11.9965C16.1333 12.9091 15.3936 13.6498 14.481 13.6498Z",
		fill: "white"
	})
});
const ForwardRef = forwardRef(SvgSupportFill);
export default ForwardRef;
